import FullPageLoader from './full-page-loader';
import ContainerLoader from './container-loader';

export interface LoaderProps {
  text?: string;
}

export { FullPageLoader, ContainerLoader };
